import auth0, { ParseHashOptions } from 'auth0-js';
import { AUTH_CONFIG } from './auth0-config';
import router from './../router';
import { store } from './../index';
import { setContext } from 'apollo-link-context';
import when from 'when';
import queryString from 'query-string';

declare var USE_AUTH;

const queryParameters = queryString.parse(location.search);

// Does only work if previously logged in
// https://auth0.com/docs/sso/current/single-page-apps#configure-silent-authentication
// This is the relevant part?
// > Have a SSO cookie for the tenant's domain (in other words, the user has previously signed in and their saved cookie is still valid);
// NOTE: We can use this by using normal login as a fallback
const AUTOMATIC_SAML_REDIRECT = queryParameters.disableAutoLogin === undefined;

// Use embedded lock instead of WebAuth?
// https://auth0.com/docs/libraries/lock/v11
// https://auth0.com/docs/libraries/lock/v9/configuration#container-string-

export default class AuthService {
  initDefer = when.defer();
  initPromise = this.initDefer.promise;

  auth0 = new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientID,
    redirectUri: AUTH_CONFIG.redirectUri,
    audience: AUTH_CONFIG.audience,
    responseType: AUTH_CONFIG.responseType,
    scope: AUTH_CONFIG.scope,
  });

  init(): boolean {
    if (!USE_AUTH) {
      this.initDefer.resolve();
      return;
    }

    this.initStore();

    if (this.isAuthenticated()) {
      this.initDefer.resolve(this);
      return true;
    } else {
      this.login();
      return false;
    }
  }

  login() {
    console.log(`Login initialized`);
    this.auth0.authorize({
      connection: 'SCA',
    });

    // if (AUTOMATIC_SAML_REDIRECT) {
    //   this.auth0.checkSession({}, (err, result) => {
    //     if (err) {
    //       console.log(`Automatic auth0 redirect failed!`, err);

    //       // Fallback to normal login
    //       this.auth0.authorize();
    //     } else {
    //       const authData = this.setSession(result);
    //       this.initDefer.resolve(this);
    //     }
    //   });
    // } else {
    //   // Display Auth0 login window
    //   this.auth0.authorize({
    //     connection: 'SCA',
    //   });
    // }

  }

  async renew() {
    console.log(`Renew auth`);

    return new Promise<any>((resolve, reject) => {
      this.auth0.checkSession({}, (err, result) => {
        if (err) {
          reject(err);
        } else {
          const authData = this.setSession(result);
          resolve(authData);
        }
      });
    });
  }

  handleAuthentication() {
    // const parseOptions = { __enableImpersonation: true } as ParseHashOptions;
    const parseOptions = {};

    this.auth0.parseHash(parseOptions, (err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult);
        this.initDefer.resolve(this);
        router.replace('/');
      } else if (err) {
        if (err.error === 'invalid_token') {
          localStorage.removeItem('access_token');
          localStorage.removeItem('id_token');
          localStorage.removeItem('expires_at');
        }

        router.replace('/');
        console.log('auth0.parseHash error:', err);
        this.initDefer.reject(err);

        store.commit('setError', {
          msg: err.error,
          permissionError: false,
        });
      }
    });
  }

  initStore() {
    const authData = {
      accessToken: localStorage.getItem('access_token'),
      idToken: localStorage.getItem('access_token'),
      expiresAt: JSON.parse(localStorage.getItem('expires_at')),
    };

    store.commit('setAuth', { auth: authData });
  }

  private clearOldNonces() {
    console.log(`Clearing old nonces`);

    Object.keys(localStorage).forEach(key => {
      if(!key.startsWith('com.auth0.auth')) {
        return;
      }

      localStorage.removeItem(key);
    });
  }

  setSession(authResult) {
    console.log(`JWT setSession`, authResult);

    this.clearOldNonces();

    const authData = {
      accessToken: authResult.accessToken,
      idToken: authResult.idToken,
      // Set the time that the access token will expire at
      expiresAt: authResult.expiresIn * 1000 + new Date().getTime(),
    };

    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', JSON.stringify(authData.expiresAt));
    store.commit('setAuth', { auth: authData });
    return authData;
  }

  logout() {

    // Unlock current project
    store.commit('releaseProjectLock');

    // Clear access token and ID token from local storage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');

    store.commit('setAuth', { auth: null });
    store.commit('setError', null);

    router.replace('/signed-out');
    // this.auth0.logout({
    //   returnTo: `${location.origin}/signed-out`,
    //   federated: true,
    // });
  }

  isAuthenticated() {
    // Check whether the current time is past the
    // access token's expiry time
    // const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    // return new Date().getTime() < expiresAt;
    return store.getters.authenticated;
  }
}

const auth = new AuthService();

export { auth };



// WEBPACK FOOTER //
// ./src/auth/AuthService.ts